import { getConfigFileName, getModule } from "@companion-core/shared/app/Utils/config";
import { getPlatform } from "@companion-core/shared/app/Utils/platform";
import { reportError } from "@companion-core/shared/app/Utils/errorReporting";
import { Category } from "@companion-core/shared/app/Components/Bell/Categories";
import { BellContent } from "@companion-core/shared/app/Store/bellStore";

export const DEFAULT_BELL_CATEGORY: Category = {
  icon: "JP-Idea",
  name: "default",
  category: "default",
  formPath: "concierge-forms/offer/default",
};

export type BellEntryOutcome = "form" | "categories" | "unavailable";

export type BellFailureReason =
  "unknownFamily" | "missingCategory" | "unloadableForm" | "bellUnavailable";

export interface BellEntryResolution {
  outcome: BellEntryOutcome;
  category?: Category;
  formPath?: string;
  failureReason?: BellFailureReason;
}

export interface BellEntryFailure {
  reason: BellFailureReason;
  outcome: BellEntryOutcome;
  family?: string;
  subfamily?: string;
  categoryName?: string;
  formPath?: string;
  offerFormPath?: string;
  contentId?: string;
  contentType?: string;
}

export const getCategoryFromName = (name: string) => {
  const categories: Category[] = getModule("concierge").modules.bell?.options.categories;
  return categories.find((category: Category) => category.name === name);
};

export const getInitialBellContent = (): BellContent => {
  const isBellHomeEnabled: boolean = getModule("concierge")?.modules.bell.options.home.enabled;
  return isBellHomeEnabled ? "home" : "categories";
};

export const reportBellEntryFailure = ({
  reason,
  outcome,
  family,
  subfamily,
  categoryName,
  formPath,
  offerFormPath,
  contentId,
  contentType,
}: BellEntryFailure): void => {
  reportError(new Error(`Bell entry failed: ${reason}`), {
    tags: {
      bellFailureReason: reason,
      bellOutcome: outcome,
      bellFamily: family ?? "unknown",
      configFileName: getConfigFileName() ?? "unknown",
      platform: getPlatform() ?? "unknown",
    },
    contexts: {
      bell: {
        family: family ?? null,
        subfamily: subfamily ?? null,
        categoryName: categoryName ?? null,
        formPath: formPath ?? null,
        offerFormPath: offerFormPath ?? null,
        contentId: contentId ?? null,
        contentType: contentType ?? null,
      },
    },
  });
};
